module.exports = __webpack_public_path__ + "img/db0d2ecb845ba14aa5a54d7ce8d173f.b9466a37.jpg";